import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { getIndicatorCountries, getNationalStrategiesCountries } from '../../../api';

const SelectEconomic = props => {

  const [selectCountry1, setSelectCountry1] = useState([]);
	const [selectCountry2, setSelectCountry2] = useState([]);
	const [selectCountry3, setSelectCountry3] = useState([]);
	const [defaultValue, setDefaultValue] = useState(null);
	const [defaultValue2, setDefaultValue2] = useState(null);
	const [defaultValue3, setDefaultValue3] = useState(null);
	const [thirdCountryDisabled, setThirdCountryDisabled] = useState(true);  

  useEffect(() => {
    loadSelectData(props.selectedCountry1, props.selectedCountry2, props.selectedCountry3);
  }, [props.selectedCountry1, props.selectedCountry2, props.selectedCountry3])

  useEffect(() => {
    if (thirdCountryDisabled == true && defaultValue2 != null && defaultValue2.value != null)
    {
      // The second country has a value and the third select is disabled, enable it
      setThirdCountryDisabled(false);
    }
    else if (defaultValue2 == null || defaultValue2.value == null)
    {
      // The third country is enabled and the second country has no value, disable it
      setThirdCountryDisabled(true);
    }
  }, [defaultValue2])

  const loadSelectData = (country1, country2, country3) => {
    try
    {
      if (props.charts) {
        getIndicatorCountries(props.charts, props.indicator, country2, country3)
				.then((res) => {
        	const data = res.resultset.find(element=> (element.code) == country1);
          let defaultValue = {};
          if (data)
          {
            defaultValue = { label: data.name, value: data.code }
          }
          else 
          {
            // The selected country is no longer available in the combo, the default value will be the first available country
            defaultValue = { label: res.resultset[0].name, value: res.resultset[0].code }
            handleSelectChange(defaultValue);
          }
          setSelectCountry1(res.resultset);
          setDefaultValue(defaultValue);
        });
          		
        getIndicatorCountries(props.charts, props.indicator, country1, country3)
        .then((res) => {
          const data = res.resultset.find(element=> (element.code) == country2);
          let defaultValue2 = {};
          if (data)
          {
            defaultValue2 = { label: data.name, value: data.code }
          }
          else
          {
            defaultValue2 = { label: props.literals.L20630, value: null }
          }
          setSelectCountry2(res.resultset);
          setDefaultValue2(defaultValue2);
        })
          		  
        getIndicatorCountries(props.charts, props.indicator, country1, country2)
				.then((res) => {
					const data = res.resultset.find(element=> (element.code) == country3);
          let defaultValue3 = {};
          if (data)
          {
            defaultValue3 = { label: data.name, value: data.code }
          }
          else
          {
            defaultValue3 = { label: props.literals.L20630, value: null }
          }
					setSelectCountry3(res.resultset);
					setDefaultValue3(defaultValue3);
        })
      } 
      else 
      {
        getNationalStrategiesCountries(country2, country3)
        .then((res) => {
          const data = res.resultset.find((element) => element.code == country1);
          let defaultValue = {}
          if (data) {
            defaultValue = { label: data.name, value: data.code}
          }
					setSelectCountry1(res.resultset);
					setDefaultValue(defaultValue);
        })
          		
        getNationalStrategiesCountries(country1, country3)
				.then((res) => {
          const data = res.resultset.find((element) => element.code == country2);
          let defaultValue2 = {}
          if (data) {
            defaultValue2 = { label: data.name, value: data.code}
          }
          else
          {
            defaultValue2 = { label: props.literals.L20630, value: null }
          }
					setSelectCountry2(res.resultset);
					setDefaultValue2(defaultValue2);
        })
          		
        getNationalStrategiesCountries(country1, country2)
        .then((res) => {
          const data = res.resultset.find((element) => element.code == country3);
          let defaultValue3 = {}
          if (data) {
            defaultValue3 = { label: data.name, value: data.code}
          }
          else
          {
            defaultValue3 = { label: props.literals.L20630, value: null }
          }
					setSelectCountry3(res.resultset);
					setDefaultValue3(defaultValue3);
				})
			}
    } catch (error) {
      console.log('Error fetching indicator countries', error);
    }
  }

    const handleSelectChange = (value) => {
      /**
       * Gets the selected country from select box 1 and sends it on the callback,
       * it also updates the countries indicator on select box 2 and 3
       */
      const country = (value.value);
      loadSelectData(country, defaultValue2.value, defaultValue3.value);
      props.handleSearch(country);
    }

    const handleSelectChange2 = (value) => {
      /**
       * Gets the selected country from select box 2 and sends it on the callback,
       * it also updates the countries indicator on select box 1 and 3
       */
      const country = (value.value);
      loadSelectData(defaultValue.value, country, defaultValue3.value);
      props.handleSearch2(country);
    }

    const handleSelectChange3 = (value) => {
      /**
       * Gets the selected country from select box 3 and sends it on the callback,
       * it also updates the countries indicator on select box 1 and 2
       */
      const country = (value.value);
      loadSelectData(defaultValue.value, defaultValue2.value, country);
      props.handleSearch3(country);
    }

    const clearFilterOption = {label: props.literals.L20901, value: null};

    const firstSelectOptions = selectCountry1.map(item=>({label: item.name, value: item.code}));
    let secondSelectOptions = selectCountry2.map(item=>({label: item.name, value: item.code}));;
    let thirdSelectOptions = selectCountry3.map(item=>({label: item.name, value: item.code}));

    if (defaultValue3 != null && defaultValue3.value != null)
    {
      thirdSelectOptions.unshift(clearFilterOption);
    }
    else if (defaultValue2 != null && defaultValue2.value != null)
    {
    	secondSelectOptions.unshift(clearFilterOption);
	  }

    if(props.selectOneCountry != null) 
    {
      return (
        <div className="compare--block container">
          <ul className="compare--list">
            <li>
              {/* Add styles for only one select */}
              <label>{props.literals.L20609}</label>
              <Select
                  onChange={ handleSelectChange }
                  value={ defaultValue }
                  className="select-component select2-container"
                  isSearchable
                  options={ firstSelectOptions }
                  getOptionLabel={ option => option.value=="EU27_2020" ? option.label :`(${option.value}) ${option.label}` }
              />
            </li>
          </ul>
        </div>
      )
    }
    else if (defaultValue != null && defaultValue2 != null && defaultValue3 != null)
    {
      return (
        <div className="compare--block container">
          {/* FILTERS */}
          <ul className="compare--list">
            {/* 1ST COUNTRY FILTER */}
            <li>
              <label>{props.literals.L20609}</label>
              <Select
                onChange={ handleSelectChange }
                value={ defaultValue }
                className="select-component select2-container"
                isSearchable
                options={ firstSelectOptions }
                getOptionLabel={ option => option.value=="EU27_2020" ? option.label :`(${option.value}) ${option.label}` }
              />
            </li>
            {/* 2ND COUNTRY FILTER */}
            <li>
              <label>{ props.literals.L20610 }</label>
              <Select
                onChange={ handleSelectChange2 }
                value={ defaultValue2 }
                className="select-component select2-container"
                isSearchable
                options={ secondSelectOptions }
                getOptionLabel={ option => option.value == null  || option.value=="EU27_2020" ? option.label :`(${option.value}) ${option.label}` }
              />          
            </li>
            {/* 3RD COUNTRY FILTER */}
            <li>
              <label>{ props.literals.L20063 }</label>
              <Select
                onChange={ handleSelectChange3 }
                value={ defaultValue3 }
                className="select-component select3-container"
                isSearchable
                isDisabled= { thirdCountryDisabled }
                options={ thirdSelectOptions }
                getOptionLabel={ option => option.value == null  || option.value=="EU27_2020" ? option.label :`(${option.value}) ${option.label}` }
              />          
            </li>
          </ul>    
			  </div>
		  );
	  }
    else
    {
		  return null;
    }
}

export default SelectEconomic;